import { Bar } from '../../components/ui/Bar.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { acompteDemandeDe, acompteRecuDe } from '../../lib/acompte-facture';
import { tr } from '../../lib/i18n';
import { C } from '../../theme/palette';
import { ChampAcompte } from '../devis/ChampsConditions.jsx';

/**
 * Le bloc « Acompte » de la facture (maquette du 29.10) : l'acompte déjà
 * reçu, qui se déduit — inscrit comme paiement à sa date, il compte dans
 * l'année où il a été touché —, et l'acompte demandé avant les travaux, que
 * le QR-facture porte d'abord. L'un et l'autre en % ou en CHF.
 *
 * @param {object} props propriétés
 * @param {object} props.form formulaire de la facture
 * @param {(f: (p: object) => object) => void} props.setForm met le formulaire à jour
 * @param {number} props.ttc total TTC de la facture
 * @returns {import('react').ReactElement} le bloc
 */
export { acompteDemandeDe, acompteRecuDe };

export function AcomptesFacture({ form, setForm, ttc }) {
  const recu = acompteRecuDe(form, ttc);
  return (
    <Card style={{ marginBottom: 11 }}>
      <Bar icon="💰" title="Acompte" color={C.amber} />
      <div style={{ padding: 13, display: 'grid', gap: 12 }}>
        <div>
          <ChampAcompte
            surFacture
            label={tr('Acompte déjà reçu (à déduire)')}
            pourcent={form.acompteRecu || 0}
            montant={form.acompteRecuMontant ?? null}
            enFrancs={!!form.acompteRecuEnFrancs}
            ttc={ttc}
            calcule={recu}
            onChange={(v) =>
              setForm((p) => ({
                ...p,
                acompteRecu: v.acompte,
                acompteRecuMontant: v.acompteMontant,
                acompteRecuEnFrancs: v.acompteEnFrancs,
              }))
            }
          />
          {recu > 0 && (
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 6 }}>
              <span style={{ fontSize: 11, color: C.grey }}>{tr('reçu le')}</span>
              <input
                aria-label={tr('Date de l’acompte reçu')}
                value={form.acompteRecuLe || ''}
                placeholder="18.12.2025"
                onChange={(e) => setForm((p) => ({ ...p, acompteRecuLe: e.target.value }))}
                style={{
                  width: 110,
                  textAlign: 'center',
                  fontWeight: 800,
                  fontSize: 14,
                  border: '1px solid ' + C.border,
                  borderRadius: 9,
                  padding: '7px',
                  color: C.ink,
                }}
              />
            </label>
          )}
          {recu > 0 && (
            <div style={{ fontSize: 10, color: C.muted, marginTop: 4, lineHeight: 1.4 }}>
              {tr(
                'Noté comme paiement reçu à cette date : il compte dans son année, et le reste à payer se calcule tout seul.',
              )}
            </div>
          )}
        </div>
        <ChampAcompte
          surFacture
          label={tr('Acompte demandé (à payer avant les travaux)')}
          pourcent={form.acompteDemande || 0}
          montant={form.acompteDemandeMontant ?? null}
          enFrancs={!!form.acompteDemandeEnFrancs}
          ttc={ttc}
          calcule={acompteDemandeDe(form, ttc)}
          onChange={(v) =>
            setForm((p) => ({
              ...p,
              acompteDemande: v.acompte,
              acompteDemandeMontant: v.acompteMontant,
              acompteDemandeEnFrancs: v.acompteEnFrancs,
            }))
          }
        />
      </div>
    </Card>
  );
}
